import {BaseResponseMessage} from "./base";
import {ClientUser} from "../user";

export namespace UserDataUpdatedCommandNamespace {
    export const COMMAND = 'user_data_updated';

    export class Response extends BaseResponseMessage {
        constructor(readonly user: ClientUser) {
            super(COMMAND, 0, true);
        }
    }
}
